import React, { useEffect, useState } from 'react'
import Alert from 'react-bootstrap/Alert'
import Helmet from 'react-helmet'
import { withRouter } from 'react-router-dom'

import DNPTable from '../components/DNPTable'
import TransportationServicesService from '../services/TransportationServicesService'

export default withRouter(({ history }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState('')
  const [items, setItems] = useState([])

  const handleDelete = item => {
    /* eslint-disable-next-line no-alert */
    if (!window.confirm(`Are you sure you want to delete ${item.name}?`)) return

    TransportationServicesService.remove(item.id)
      .then(() => {
        setItems(prev => prev.filter(i => i.id !== item.id))
      })
      .catch(err => {
        /* eslint-disable-next-line no-alert */
        alert(err.message)
      })
  }

  useEffect(() => {
    TransportationServicesService.getAll()
      .then(data => {
        setItems(data)
        setIsLoading(false)
      })
      .catch(err => {
        setError(err.message)
        setIsLoading(false)
      })
  }, [])

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center mt-2">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }

  return (
    <div className="container mt-2 pb-3">
      <Helmet title="Transportation Services" />
      {!!error && (
        <Alert variant="danger" className="mb-4 pr-5 pl-5">
          <strong>Error:</strong> <pre className="mb-0">{error}</pre>
        </Alert>
      )}
      <div className="d-flex justify-content-end my-4">
        <a className="main-link" href={`/library/transportation-services/add`}>
          Add Transportation Service
        </a>
      </div>
      <DNPTable
        items={items}
        columns={[
          {
            title: 'Name',
            getText: item => <a href={`/library/transportation-services/${item.id}`}>{item.name}</a>,
          },
          { title: 'Phone', getText: item => item.phone },
          { title: 'Email', getText: item => item.email },
          {
            title: '',
            getText: item => (
              <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(item)}>
                Delete
              </button>
            ),
          },
        ]}
        noItemsText="No transportation services have been added"
      />
    </div>
  )
})
